import React, { ReactNode } from 'react';

/**
 * Возвращает форму множественного числа соответствующую переданному числу для русского языка
 *
 * Пример: plural(5, ['капля', 'капели', 'капель']);
 * Эквивалент: plural(5, 'капля', 'капели', 'капель');
 *
 * @param number Число для определения множественной формы
 * @param options Массив форм [one, few, many] или форма one
 * @param few Форма few (если options строка)
 * @param many Форма many (если options строка)
 */
const pluralize = <T>(number: number, options: T[] | T, few?: T, many?: T) => {
  many = many || few;
  let titles = options instanceof Array ? options : [options, few, many];
  let cases = [2, 0, 1, 1, 1, 2];
  return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
};

export default pluralize;
